export const SET_SUBCATEGORIES = 'SET_SUBCATEGORIES'
export const ADD_SUBCATEGORY = 'ADD_SUBCATEGORY'
export const UPDATE_SUBCATEGORY = 'UPDATE_SUBCATEGORY'
export const DELETE_SUBCATEGORY = 'DELETE_SUBCATEGORY'
